var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTiming(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 52,
    viewBox: "0 0 46 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_138_2727)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.9401 1.2168L33.9944 7.39768L44.9298 13.5786V26.0592V38.4209L33.9944 44.6018L22.9401 50.7827L12.0047 44.6018L1.06934 38.4209V26.0592V13.5786L12.0047 7.39768L22.9401 1.2168Z",
    fill: "white",
    fillOpacity: 0.501961
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.9408 3.83203L32.8064 9.41859L42.5532 15.0052V26.0594V37.1137L32.8064 42.5814L22.9408 48.1679L13.194 42.5814L3.44727 37.1137V26.0594V15.0052L13.194 9.41859L22.9408 3.83203Z",
    fill: "white",
    stroke: "#999999",
    strokeWidth: 2.02067,
    strokeMiterlimit: 2.61313
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.9406 0.0283203L34.4703 6.56579L46 12.9844V26.0593V39.0154L34.4703 45.5529L22.9406 51.9715L11.5297 45.5529L0 39.0154V26.0593V12.9844L11.5297 6.56579L22.9406 0.0283203ZM22.9406 1.21695L33.9948 7.39783L44.9302 13.5787V26.0593V38.4211L33.9948 44.602L22.9406 50.7828L12.0052 44.602L1.06977 38.4211V26.0593V13.5787L12.0052 7.39783L22.9406 1.21695Z",
    fill: "#CCCCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9407 40.5607C30.9496 40.5607 37.442 34.0682 37.442 26.0594C37.442 18.0506 30.9496 11.5581 22.9407 11.5581C14.9319 11.5581 8.43945 18.0506 8.43945 26.0594C8.43945 34.0682 14.9319 40.5607 22.9407 40.5607Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9411 35.806C28.3241 35.806 32.6879 31.4423 32.6879 26.0593C32.6879 20.6763 28.3241 16.3125 22.9411 16.3125C17.5581 16.3125 13.1943 20.6763 13.1943 26.0593C13.1943 31.4423 17.5581 35.806 22.9411 35.806Z",
    fill: "#CCCCFF",
    stroke: "white",
    strokeWidth: 2.02067,
    strokeMiterlimit: 2.61313
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9406 30.5761C25.4352 30.5761 27.4574 28.5538 27.4574 26.0593C27.4574 23.5647 25.4352 21.5425 22.9406 21.5425C20.4461 21.5425 18.4238 23.5647 18.4238 26.0593C18.4238 28.5538 20.4461 30.5761 22.9406 30.5761Z",
    fill: "#FF99CC",
    stroke: "white",
    strokeWidth: 2.02067,
    strokeMiterlimit: 2.61313
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2354 20.2354L23.654 25.3465L25.318 28.318L22.2276 26.7728L17.2354 20.2354Z",
    fill: "#9933CC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.3312 16.6694L23.6542 26.7728L20.6826 28.318L22.2278 25.3464L32.3312 16.6694Z",
    fill: "#9933CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9404 26.8916C23.4 26.8916 23.7725 26.5191 23.7725 26.0596C23.7725 25.6001 23.4 25.2275 22.9404 25.2275C22.4809 25.2275 22.1084 25.6001 22.1084 26.0596C22.1084 26.5191 22.4809 26.8916 22.9404 26.8916Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_138_2727"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 52,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiming);
export default __webpack_public_path__ + "static/media/Timing.20ddee245e9a1bdd0c44e302addafdf2.svg";
export { ForwardRef as ReactComponent };